export const EURO_COUNTRY_LIST = [
    'at',
    'be',
    'bg',
    'hr',
    'ch',
    'cy',
    'cz',
    'de',
    'dk',
    'ee',
    'el',
    'fi',
    'fr',
    'gb',
    'gr',
    'hu',
    'ie',
    'it',
    'lv',
    'lt',
    'lu',
    'mt',
    'nl',
    'pl',
    'pt',
    'ro',
    'sk',
    'si',
    'es',
    'se',
    'no',
    'is',
    'li',
];
export const EURO_COUNTRY_SET = new Set(EURO_COUNTRY_LIST);
export const isEuropeRegion = (region) => EURO_COUNTRY_SET.has(region);
